export default "__VITE_ASSET__146f3154__"